/**
* @module SDKModule
* @author Jonathan Casarrubias <t:@johncasarrubias> <gh:jonathan-casarrubias>
* @license MIT 2016 Jonathan Casarrubias
* @version 2.1.0
* @description
* The SDKModule is a generated Software Development Kit automatically built by
* the LoopBack SDK Builder open source module.
*
* The SDKModule provides Angular 2 >= RC.5 support, which means that NgModules
* can import this Software Development Kit as follows:
*
*
* APP Route Module Context
* ============================================================================
* import { NgModule }       from '@angular/core';
* import { BrowserModule }  from '@angular/platform-browser';
* // App Root 
* import { AppComponent }   from './app.component';
* // Feature Modules
* import { SDK[Browser|Node|Native]Module } from './shared/sdk/sdk.module';
* // Import Routing
* import { routing }        from './app.routing';
* @NgModule({
*  imports: [
*    BrowserModule,
*    routing,
*    SDK[Browser|Node|Native]Module.forRoot()
*  ],
*  declarations: [ AppComponent ],
*  bootstrap:    [ AppComponent ]
* })
* export class AppModule { }
*
**/
import { JSONSearchParams } from './services/core/search.params';
import { ErrorHandler } from './services/core/error.service';
import { LoopBackAuth } from './services/core/auth.service';
import { LoggerService } from './services/custom/logger.service';
import { SDKModels } from './services/custom/SDKModels';
import { InternalStorage, SDKStorage } from './storage/storage.swaps';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CookieBrowser } from './storage/cookie.browser';
import { StorageBrowser } from './storage/storage.browser';
import { SocketBrowser } from './sockets/socket.browser';
import { SocketDriver } from './sockets/socket.driver';
import { SocketConnection } from './sockets/socket.connections';
import { RealTime } from './services/core/real.time';
import { UserApi } from './services/custom/User';
import { InstitutionsApi } from './services/custom/Institutions';
import { SectorApi } from './services/custom/Sector';
import { ReportApi } from './services/custom/Report';
import { PopulationCountApi } from './services/custom/PopulationCount';
import { ReportsMediaApi } from './services/custom/ReportsMedia';
import { FundAccountApi } from './services/custom/FundAccount';
import { PopulationCategoryApi } from './services/custom/PopulationCategory';
import { CountyApi } from './services/custom/County';
import { SubCountyApi } from './services/custom/SubCounty';
import { FundsAccountApi } from './services/custom/FundsAccount';
import { VoteHeadsApi } from './services/custom/VoteHeads';
import { VoteHeadAllocationApi } from './services/custom/VoteHeadAllocation';
import { AnnualBreakdownApi } from './services/custom/AnnualBreakdown';
import { FundsAllocatedApi } from './services/custom/FundsAllocated';
import { FundsExpenditureApi } from './services/custom/FundsExpenditure';
import { UserAccountApi } from './services/custom/UserAccount';
import { SectorTypeApi } from './services/custom/SectorType';
import { SectorCategoryApi } from './services/custom/SectorCategory';
import { InstitutionVersionApi } from './services/custom/InstitutionVersion';
import { DocumentApi } from './services/custom/Document';
import { TempApi } from './services/custom/Temp';
import { FundsBudgetedApi } from './services/custom/FundsBudgeted';
import { AccountSupportFundApi } from './services/custom/AccountSupportFund';
import { AccountIncomeSourceApi } from './services/custom/AccountIncomeSource';
import { ConstituencyApi } from './services/custom/Constituency';
import { FeedBackApi } from './services/custom/FeedBack';
import { NewsFeedApi } from './services/custom/NewsFeed';
import { FilesApi } from './services/custom/Files';
import { FileManagerApi } from './services/custom/FileManager';
import { AnalyticsApi } from './services/custom/Analytics';
import { ServiceCharterGroupApi } from './services/custom/ServiceCharterGroup';
import { SampleApi } from './services/custom/Sample';
import { BudgetBreakdownItemApi } from './services/custom/BudgetBreakdownItem';
import { ReportCommentApi } from './services/custom/ReportComment';
import { ServiceCharterGroupingApi } from './services/custom/ServiceCharterGrouping';
import { DigitalToolApi } from './services/custom/DigitalTool';
import { SurveyApi } from './services/custom/Survey';
import { SApi } from './services/custom/S';
import { ProjectApi } from './services/custom/Project';
import { ProjectFunderApi } from './services/custom/ProjectFunder';
import { ImageApi } from './services/custom/Image';
import { MilestoneApi } from './services/custom/Milestone';
import { WardApi } from './services/custom/Ward';
/**
* @module SDKBrowserModule
* @description
* This module should be imported when building a Web Application in the following scenarios:
*
*  1.- Regular web application
*  2.- Angular universal application (Browser Portion)
*  3.- Progressive applications (Angular Mobile, Ionic, WebViews, etc)
**/
@NgModule({
  imports:      [ CommonModule, HttpModule ],
  declarations: [ ],
  exports:      [ ],
  providers:    [
    ErrorHandler,
    SocketConnection
  ]
})
export class SDKBrowserModule {
  static forRoot(internalStorageProvider: any = {
    provide: InternalStorage,
    useClass: CookieBrowser
  }): ModuleWithProviders {
    return {
      ngModule  : SDKBrowserModule,
      providers : [
        LoopBackAuth,
        LoggerService,
        JSONSearchParams,
        SDKModels,
        RealTime,
        UserApi,
        InstitutionsApi,
        SectorApi,
        ReportApi,
        PopulationCountApi,
        ReportsMediaApi,
        FundAccountApi,
        PopulationCategoryApi,
        CountyApi,
        SubCountyApi,
        FundsAccountApi,
        VoteHeadsApi,
        VoteHeadAllocationApi,
        AnnualBreakdownApi,
        FundsAllocatedApi,
        FundsExpenditureApi,
        UserAccountApi,
        SectorTypeApi,
        SectorCategoryApi,
        InstitutionVersionApi,
        DocumentApi,
        TempApi,
        FundsBudgetedApi,
        AccountSupportFundApi,
        AccountIncomeSourceApi,
        ConstituencyApi,
        FeedBackApi,
        NewsFeedApi,
        FilesApi,
        FileManagerApi,
        AnalyticsApi,
        ServiceCharterGroupApi,
        SampleApi,
        BudgetBreakdownItemApi,
        ReportCommentApi,
        ServiceCharterGroupingApi,
        DigitalToolApi,
        SurveyApi,
        SApi,
        ProjectApi,
        ProjectFunderApi,
        ImageApi,
        MilestoneApi,
        WardApi,
        internalStorageProvider,
        { provide: SDKStorage, useClass: StorageBrowser },
        { provide: SocketDriver, useClass: SocketBrowser }
      ]
    };
  }
}
/**
* Have Fun!!!
* - Jon
**/
export * from './models/index';
export * from './services/index';
export * from './lb.config';
export * from './storage/storage.swaps';
export { CookieBrowser } from './storage/cookie.browser';
export { StorageBrowser } from './storage/storage.browser';



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/index.ts